import React from 'react';
import { Link, Drawer } from '@common/components';
import { Button, Space } from 'antd';
import { StaffingRequestTemplateDetailsContent } from './_staffing-request-template-details-content';

export function StaffingRequestTemplateDetailsDrawer({
  open,
  onClose,
  templateId,
}: {
  open: boolean;
  onClose: () => void;
  templateId?: string;
}) {
  const footer = (
    <Space>
      <Button size="large" onClick={onClose}>
        Cancel
      </Button>
      <Link to={`/works/staffing-requests/new/${templateId}`}>
        <Button size="large" type="primary">
          Continue Staffing Request
        </Button>
      </Link>
    </Space>
  );

  return (
    <Drawer
      open={open}
      title="Template Details"
      onClose={onClose}
      footer={footer}
    >
      {templateId && (
        <StaffingRequestTemplateDetailsContent templateId={templateId} />
      )}
    </Drawer>
  );
}
